import { List,Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const TablePasteResultRecord = Record({
  success: true,
  errorMessage: null,
  newRowIds: List(),
  bulkChanges: List()
});

const data = {
  objects: {
    newRowIds: "List"
  },
  collections: {
    bulkChanges: "TablePastedDataRecord"
  }
};
createFromJS.registerCallback(
  "TablePasteResultRecord",
  createFromJS.createNestedCallback(TablePasteResultRecord, data)
);
